module.exports = __webpack_public_path__ + "static/media/printing-services-img9.0378f445.jpg";